import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { ProductResponse } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';


export type DTO1 = {
    page: number;
    perPage: number;
    search?: string;
    filter?: any;
};

export const getInstituteList = (
    {  page, perPage, search, filter }: DTO1 = {
      page: 1,
      perPage: 20,
    }
  ): Promise<ProductResponse> => {
    return axios.post(`/superAdmin/institute-list`,  {
      page,
      perPage,
      search,
      filter
     });
  };


type UseOptions = {
  config?: MutationConfig<typeof getInstituteList>;
};

export const useGetInstituteList= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getInstituteList,
  });
};



//////ADD PRODUCT

export type saveData = {
    id?: number;
    name: string;
    description?:string;
    color?:string;
  };
  
  export const addProduct = ({
    id,
    name,color,description
  }: saveData) => {
    if(id){
        return axios.post(`/superAdmin/product/update`, {
            id,
            name,
            description,
            color
           });
    }else{
        return axios.put(`/superAdmin/product/add`, {
            name,
            description,
            color
           });
    }
    
  };
  
  type UseAddPetOptions = {
    config?: MutationConfig<typeof addProduct>;
  };
  
  export const useAddProduct = ({ config }: UseAddPetOptions = {}) => {
    return useMutation({
      onSuccess: (res: any, req: any) => {
        showNotification({
          type: 'success',
          title: 'Product updated successfully.',
        });
      },
      ...config,
      mutationFn: addProduct,
    });
  };
  